export class C_Customization {
  AutoAcceptOddUpChanges: boolean;
  AutoAcceptOddDownChanges: boolean;
  constructor(autoAcceptOddUpChanges: boolean, autoAcceptOddDownChanges: boolean) {
    this.AutoAcceptOddUpChanges = String(autoAcceptOddUpChanges).toLowerCase() === "true";
    this.AutoAcceptOddDownChanges = String(autoAcceptOddDownChanges).toLowerCase() === "true";
  }
}
